import { gql } from '@apollo/client';

export const GET_DEPENDENTS_COUNTER = gql`
  query GetDependentsCounterQuery {
    profile {
      id
      dependentsCounter
    }
  }
`;
